import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { TopicsContext } from '../../contexts/Topics';
import { UsersContext } from '../../contexts/Users';
import { ITEM_STATUS } from '../../models/Completion';
import StatusLight from '../common/StatusLight';
import * as CSS from './elements/Module.js';

const Tasks = observer(({ moduleId, topicId }) => {
  const usersStore = useContext(UsersContext);
  const topicsStore = useContext(TopicsContext);
  const module = topicsStore.getModuleById(moduleId);
  const loggedInUser = usersStore.getLoggedInUser();
  const tasks = module.getOrderedItems('tasks');
  return (
    <CSS.StudentItemList>
      {tasks.length ? (
        tasks.map((task) => {
          const status = loggedInUser.private.getItemStatus(task.id, 'tasks');
          const hasUpdates = loggedInUser.private.hasUpdatesForUser(
            task.id,
            'tasks',
            loggedInUser
          );
          return (
            <CSS.ItemLi key={task.id}>
              <CSS.TaskRowLink
                to={`/topics/${topicId}/modules/${moduleId}/tasks/${task.id}`}
              >
                <CSS.StudentTaskUpdateDot
                  show={hasUpdates}
                  data-testid={`updates-${task.id}`}
                >
                  <CSS.ItemInstructions
                    complete={status === ITEM_STATUS.complete}
                    hasNotifications
                  >
                    {task.instructions}
                  </CSS.ItemInstructions>
                </CSS.StudentTaskUpdateDot>
                <StatusLight status={status} itemId={task.id} />
              </CSS.TaskRowLink>
            </CSS.ItemLi>
          );
        })
      ) : (
        <CSS.NoItemsLi>
          <CSS.ItemInstructions complete={true}>
            No tasks yet
          </CSS.ItemInstructions>
        </CSS.NoItemsLi>
      )}
    </CSS.StudentItemList>
  );
});

export default Tasks;
